import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template"]
  static values = { placeholder: String }

  add(event) {
    event.preventDefault()

    const placeholder = this.placeholderValue || "NEW_RECORD"
    const index = `${Date.now()}${Math.floor(Math.random() * 1000)}`
    const content = this.templateTarget.innerHTML.replaceAll(placeholder, index)

    this.containerTarget.insertAdjacentHTML("beforeend", content)
  }

  remove(event) {
    event.preventDefault()

    const row = event.target.closest("[data-nested-form-row]")
    if (!row) return

    const destroyInput = row.querySelector("input[name*='[_destroy]']")

    if (destroyInput) {
      destroyInput.value = "1"
      row.classList.add("d-none")
    } else {
      row.remove()
    }
  }
}
